import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import estimateField from "../../../../../service/estimateFields/estimateField"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./designDaysShortening.png"

const 納期短縮対応 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { designDaysShortening: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="納期短縮対応" src={img} helpURL={HELP_LINKS["納期短縮対応"]}>
      <RadioGroup
        name={estimateField.designDaysShortening.key}
        selectedValue={values.designDaysShortening}
        onChange={handlers.radio}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["納期短縮対応"].あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT["納期短縮対応"].なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.designDaysShortening} />
    </OneClickField>
  )
}

export default 納期短縮対応
